module.exports = "/media/close_black.98eaf4a9.png";